import { createStyles, Theme } from '@material-ui/core/styles';
import type { ModalProps } from './Modal';

const styles = (theme: Theme) => createStyles({
  paper: {
    padding: ({ noPadding }: ModalProps) => (noPadding ? 0 : theme.spacing(10)),
    paddingRight: ({ noPadding }: ModalProps) => (noPadding ? 0 : theme.spacing(8)),
    maxWidth: ({ fullScreen }: ModalProps) => (fullScreen ? '100%' : theme.spacing(120)),
    width: ({ fullScreen }: ModalProps) => (fullScreen ? '100%' : theme.spacing(120)),
    backgroundColor: theme.colors.layout.backgroundPrimary,
    textAlign: ({ isPopUp }: ModalProps) => (isPopUp ? 'center' : 'initial'),
    borderRadius:
      theme.flags.boxStyle === 'stroke' ? 0 : theme.borders.radius3,
  },
  closeHeaderBtn: {
    position: 'absolute',
    right: `${theme.spacing(4)}px`,
    top: `${theme.spacing(4)}px`,
  },
  dialogActions: {
    justifyContent: ({ isPopUp }: ModalProps) => (isPopUp ? 'center' : 'flex-start'),
    marginTop: ({ isPopUp }: ModalProps) => (isPopUp ? theme.spacing(6) : theme.spacing(8)),
    padding: 0,
    columnGap: theme.spacing(3),
  },
  dialogTitle: {
    ...theme.typography.h2,
    padding: 0,
  },
  dialogContent: {
    padding: 0,
    paddingRight: ({ noPadding }: ModalProps) => (noPadding ? 0 : theme.spacing(2)),
    paddingLeft: ({ noPadding }: ModalProps) => (noPadding ? 0 : 2),
    paddingTop: ({ noPadding }: ModalProps) => (noPadding ? 0 : theme.spacing(1)),
  },
  icon: {
    marginBottom: theme.spacing(4),
  },
});

export default styles;
